import { Button, DialogActions, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { ConnectionConfigInfoModel } from '../../../models';
import { padZeroToStart } from '../../../utils';

export type ConnectionConfigInfo_TJ360VersionDeviceDialogProps = {
    isOpen: boolean;
    onOK: (data: any) => void;
    onCancel: () => void;
    data: any;
};

export const ConnectionConfigInfo_TJ360VersionDeviceDialog = (props: ConnectionConfigInfo_TJ360VersionDeviceDialogProps) => {
    const { isOpen, onOK, onCancel, data } = props;
    const [open, setOpen] = React.useState(isOpen);

    const { control, handleSubmit, formState: { errors }, setValue } = useForm<ConnectionConfigInfoModel>({
        mode: 'all',
        criteriaMode: "all",
        defaultValues: data,
    });

    const handleEditSubmit = (data:any) => {
        onOK(data);
    }

    // Cancelボタンイベント
    const handleCancel = () => {
        setOpen(false);
        onCancel();
    };

    const handleInputOnBlur = (e: any, name: any, maxLength: number) => {
        setValue(name, padZeroToStart(e.target.value, maxLength));
    }

    return (
        <div>
            <Dialog open={open} maxWidth={"md"} fullWidth>
                <form onSubmit={handleSubmit(handleEditSubmit)} style={{ width: '90%', margin: 'auto' }}>
                    <DialogTitle>Connection設定情報</DialogTitle>
                    <DialogContent sx={{ pb: 1.5 }}>
                        <Stack spacing={2.5} style={{ marginLeft: '10px', width: '98%', position:"relative" }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} mb={1}>
                                    <FormControl fullWidth
                                        size="small" error={!!errors?.parentOrChild}>
                                        <InputLabel>親機/子機設定</InputLabel>
                                        <Controller
                                            name="parentOrChild"
                                            control={control}
                                            rules={{ required: '必須項目です。入力してください。' }}
                                            render={({ field } : any) => (
                                                <>
                                                    <Select
                                                        {...field}
                                                        label="親機/子機設定"
                                                        error={!!errors?.parentOrChild}
                                                        size="small"
                                                    >
                                                        <MenuItem value="0">Gateway</MenuItem>
                                                        <MenuItem value="1">Periperal</MenuItem>
                                                    </Select>
                                                    {
                                                        !!errors?.parentOrChild &&
                                                        <FormHelperText style={{ color: 'red' }}>{errors?.parentOrChild?.message}</FormHelperText>
                                                    }</>
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} mb={1}>
                                    <Controller
                                        control={control}
                                        name="panId"
                                        rules={{
                                            pattern: {
                                                value: /^[a-zA-Z0-9]{1,2}$/,
                                                message: '英数字を入力してください。'
                                            }
                                        }}
                                        render={({ field }) => (
                                            <>
                                                <TextField
                                                    {...field}
                                                    fullWidth
                                                    type="text"
                                                    label={`PAN ID`}
                                                    size="small"
                                                    error={!!errors?.panId}
                                                    helperText={errors?.panId?.message}
                                                    inputProps={{ maxLength: 2 }}
                                                    onBlur={(e) => {
                                                        handleInputOnBlur(e, 'panId', 2);
                                                    }}
                                                />
                                            </>
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Controller
                                        control={control}
                                        name="extendPanId"
                                        rules={{
                                            pattern: {
                                                value: /^[a-zA-Z0-9]{1,8}$/,
                                                message: '英数字を入力してください。'
                                            }
                                        }}
                                        render={({ field }) => (
                                            <>
                                                <TextField
                                                    {...field}
                                                    fullWidth
                                                    type="text"
                                                    label={`Extend PAN ID`}
                                                    size="small"
                                                    error={!!errors?.extendPanId}
                                                    helperText={errors?.extendPanId?.message}
                                                    inputProps={{ maxLength: 8 }}
                                                    onBlur={(e) => {
                                                        handleInputOnBlur(e, 'extendPanId', 8);
                                                    }}
                                                />
                                            </>
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Stack>
                    </DialogContent>
                    <DialogActions>
                       <Stack direction='row' justifyContent="flex-end" spacing={2} sx={{ mt: 2, mr: 2,mb: 2 }}>
                           <Button color="inherit" variant="contained" onClick={handleCancel}>キャンセル</Button>
                           <Button variant="contained" type='submit'>保存</Button>
                       </Stack>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    );
}

export default ConnectionConfigInfo_TJ360VersionDeviceDialog;